import NarrativeVoting from '@/pages/Narrative/components/NarrativeVoting';
import { CommentNarrative } from '../CommentNarrative';
import { SetFairValue } from '../SetFairValue';
import { useRef } from 'react';
import { Button } from '@simplywallst/ui-core/next';

import { usePathname } from '@/hooks/location/usePathname';
import type { Narrative } from '../../hooks/useNarrative';
import { NarrativeEditButton } from '../NarrativeEditButton';
import { useTracking } from 'react-tracking';
// NOTE: This is hardcoded temporarily to show a link for particular narratives.
const NARRATIVE_LINKS = {
  'e84dcb87-8b97-4a56-9dbc-664354cb58cd': 'https://ir.silopharma.com', // SILO
  '5ca876d4-8480-48ec-a2c1-84da3f4df242':
    'https://stockresearchtoday.com/delivering-therapy-where-it-matters', // RNXT
};

type Props = {
  narrative: Narrative;
  onCommentClick: () => void;
};

export const NarrativeActions = ({ narrative, onCommentClick }: Props) => {
  const { id, slug, company, voteCount, isSponsored } = narrative;
  const containerRef = useRef<HTMLDivElement>(null);
  const pathname = usePathname();
  const { trackEvent } = useTracking();

  if (!company) return null;

  return (
    <div className="flex w-full flex-wrap justify-start gap-2">
      <SetFairValue
        companyId={company.id}
        narrativeId={id}
        containerRef={containerRef}
        primaryNarrativeCount={narrative.primaryCount}
        isPrimary={narrative.isPrimary}
      />
      {/* NOTE: We'll enable this button when we have third party links provided */}
      {isSponsored && NARRATIVE_LINKS[id] !== undefined && (
        <Button
          variant="primary"
          href={NARRATIVE_LINKS[id]}
          size="medium"
          onClick={() =>
            trackEvent({
              subject: 'header',
              action: 'click',
              modifier: 'learnMore',
              narrativeId: id,
            })
          }
        >
          Learn about {company.tickerSymbol}
        </Button>
      )}
      <NarrativeEditButton
        narrative={narrative}
        returnPath={pathname}
        size="medium"
      />
      <NarrativeVoting
        narrativeId={id}
        slug={slug}
        upVotes={voteCount.upvotes}
      />
      <CommentNarrative
        commentKey={narrative.commentKey}
        commentCount={narrative.commentCount}
        onCommentClick={onCommentClick}
      />
    </div>
  );
};
